<script setup>
import { ArrowLongRightIcon } from "@heroicons/vue/24/outline";
const props = defineProps({
  size: {
    type: String,
    default: "regular",
  },
  label: String,
});
</script>

<template>
  <UiButton
    v-bind="$attrs"
    :class="{ 'px-10': size === 'regular' }"
    class="tracking-[0.2em] rounded-none uppercase letter-spacing-2 transition py-6 w-auto"
  >
    <span class="font-light mr-2">{{ label }}</span>
    <ArrowLongRightIcon class="h-4 w-4" aria-hidden="true" />
  </UiButton>
</template>
